import styled, { css } from 'styled-components'
import BaseInput from 'components/Input'
import { ReactComponent as BaseLinkIcon } from 'icons/link-12.svg'
import { Flex } from 'components/Box'
import { ToggleWrapper } from '../AccessLevelSelect'
import { truncateStyles } from 'components/Truncate'
import CopyToClipboard from 'components/CopyToClipboard'

interface InvitePeopleInputWrapperProps {
  disabled: boolean
}

const InvitePeopleInputWrapper = styled(Flex)<InvitePeopleInputWrapperProps>(
  ({ theme, disabled }) => css`
    flex: 1;
    align-items: center;
    height: 40px;
    border-radius: 4px;
    background-color: ${theme.colors.background.secondary[2]};
    border: 1px ${disabled ? 'dashed' : 'solid'} ${theme.colors.border[1]};
    padding-left: 12px;
  `
)

const LinkInviteInput = styled(BaseInput)`
  height: 38px;
  margin-right: 4px;

  &[type='text'] {
    font-size: ${({ theme }) => theme.fontSizes.smaller};
    border: none;
    padding-right: 0;
    ${truncateStyles};

    :disabled {
      background-color: ${({ theme }) =>
        theme.colors.background.light.secondary};
    }
  }
`

const CopyButton = styled(CopyToClipboard)`
  min-width: 82px;
`

const AccessLevelSelectInvite = styled.div`
  margin-left: auto;

  & ${ToggleWrapper} {
    width: 115px;
    border: none;
    box-shadow: none;
    margin-right: 4px;
  }

  & button:hover,
  & button:focus {
    background-color: ${({ theme }) => theme.colors.concrete};
    transition: background-color 0.3s ease-out;
  }
`

const iconStyles = css`
  width: 12px;
  min-width: 12px;
  height: 12px;
  min-height: 12px;
  color: ${({ theme }) => theme.colors.text.dark.secondary};
`

const LinkIcon = styled(BaseLinkIcon)`
  ${iconStyles}
`

export {
  AccessLevelSelectInvite,
  LinkIcon,
  InvitePeopleInputWrapper,
  LinkInviteInput,
  CopyButton,
}
